import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const RevenueByTitleTable = ({ titles }) => {
  const { t } = useTranslation("financials");

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            fontSize: "0.875rem",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("revenueByTitle.title")}
        </Typography>

        {!titles || titles.length === 0 ? (
          <Typography color="text.secondary">
            {t("revenueByTitle.noTitles")}
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{t("revenueByTitle.columns.title")}</TableCell>
                <TableCell align="right">
                  {t("revenueByTitle.columns.gross")}
                </TableCell>
                <TableCell align="right">
                  {t("revenueByTitle.columns.expenses")}
                </TableCell>
                <TableCell align="right">
                  {t("revenueByTitle.columns.net")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {titles.map((title) => (
                <TableRow key={title.asset_id}>
                  <TableCell sx={{ fontWeight: 500 }}>
                    {title.asset_title}
                  </TableCell>
                  <TableCell align="right">
                    ${title.gross_revenue?.toFixed(2)}
                  </TableCell>
                  <TableCell align="right" sx={{ color: "error.main" }}>
                    -${title.total_expenses?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontWeight: 600,
                      color:
                        title.net_revenue >= 0 ? "success.main" : "error.main",
                    }}
                  >
                    ${title.net_revenue?.toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default RevenueByTitleTable;
